import React, { useCallback, useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { Select } from "antd";
import "antd/dist/reset.css";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { privacySelectStyles } from "../../selectStyles";
import SelectPrivacy from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import parse from "html-react-parser";
import Delta from "quill-delta";
// import Cropper from "react-easy-crop";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";


// Utility function for creating image from URL
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

// Convert degrees to radians
function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

// Function to get cropped image
async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const maxSize = Math.max(image.width, image.height);
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

  // Set canvas dimensions
  canvas.width = safeArea;
  canvas.height = safeArea;

  // Translate canvas context for rotation
  ctx.translate(safeArea / 2, safeArea / 2);
  ctx.rotate(getRadianAngle(rotation));
  ctx.translate(-safeArea / 2, -safeArea / 2);

  // Draw rotated image
  ctx.drawImage(
    image,
    safeArea / 2 - image.width * 0.5,
    safeArea / 2 - image.height * 0.5
  );
  const data = ctx.getImageData(0, 0, safeArea, safeArea);

  // Set canvas to final crop size
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Place image data at correct position
  ctx.putImageData(
    data,
    Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
    Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
  );

  // Return as a blob URL
  return new Promise((resolve) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, "image/jpeg");
  });
}

const ArticleUpdate = ({
  showModal,
  articleSlug,
  closeModal,
  postId,
  articleId,
  onUpdateSuccess,
  ImageUrl,
  setPostList,
  articleTagName,
  article,
  setArticle,

}) => {
  const { t } = useTranslation();

  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalArticleData, setOriginalArticleData] = useState(null);
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
  const language = localStorage.getItem("Lang");

  const [SearchText, setSearchText] = useState("")
  const [selectedIndex, setSelectedIndex] = useState(0);
  const itemRefs = useRef([]);
  const [articleDataInfo, setArticleDataInfo] = useState();

  // Fetch the article data when the modal opens
  useEffect(() => {
    if (showModal && postId) {
      fetchArticleData();
    }
  }, [showModal, postId]);

  useEffect(() => {
    if (ImageUrl) {
      setPreviewImageUrl(ImageUrl);
      setOriginalBannerUrl((prev) => prev || ImageUrl);
    }
  }, [ImageUrl]);


  // Function to fetch article data
  const fetchArticleData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `/Posts/GetArticleInfo?DeviceType=Web&PostId=${postId}&TitleSlug=${articleSlug}&langKey=${language}`
      );
      const articleData = response.data.responseData;
      console.log("articleData", articleData);
      setArticleDataInfo(articleData)
      // Set the original data for reference
      setOriginalArticleData(articleData);
      // console.log("articleData2222111", articleData, articleData.articleTags_Name);
      // console.log("articleData.articleTags_Name", articleData.articleTags_Name); 

      setSelectedTags(articleData.articleTags_Name);

      // Populate the form with existing data
      setTitle(articleData?.info?.postInfo?.articleInfo?.title || "");
      setDescription(articleData?.info?.postInfo?.postContent || "");
      setPostInputValue(articleData.postInfo.postContent || "");

      // Set dynamic values if they exist
      if (articleData?.info?.postInfo.dynamicValues) {
        setPostDynamicValues(articleData?.info?.postInfo.dynamicValues);
      }

      if (
        Array.isArray(articleData.articleTags_Name) &&
        articleData.articleTags_Name.length > 0
      ) {
        setSelectedTags(articleData.articleTags_Name.map((i) => i));
        console.log(" Tags set from articleData", articleData.articleTags_Name);
      }

      // Set privacy type
      setPrivacyType(articleData?.info?.postInfo.privacyType || "Public");
      const bannerUrl = articleData?.info?.postInfo?.mediaFilesList?.[0]?.mediaName;
      if (bannerUrl) {
        setImagePreviewFromUrl(bannerUrl);
        setImagePreview(bannerUrl);
        setOriginalBannerUrl(bannerUrl);
        setBannerImage(bannerUrl);

      }

      // Handle banner image if it exists
      // if (
      //   articleData?.info?.postInfo.mediaFilesList &&
      //   articleData?.info?.postInfo.mediaFilesList.length > 0
      // ) {
      // const bannerUrl = articleData?.info?.postInfo.mediaFilesList[0].mediaName;
      // setImagePreviewFromUrl(bannerUrl);
      // }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching article data:", error);
      setErrorToastMessage("Failed to load article data");
      setShowErrorToast(true);
      setIsLoading(false);
    }
  };

  // Function to handle fetching image from URL and preparing it for the form
  const setImagePreviewFromUrl = async (url) => {
    try {
      // Create a temporary image preview from the URL
      setPreviewImageUrl(url);
    } catch (error) {
      console.error("Error setting image preview:", error);
    }
  };

  const replaceDynamicValues = (content, dynamicValues = []) => {
    console.log("Replce value===>", dynamicValues)
    if (!content || !dynamicValues) return content;
    const safeDynamicValues = Array.isArray(dynamicValues) ? dynamicValues : [];
    let result = content;
    safeDynamicValues.forEach((item) => {
      console.log("Item===>", item)
      const placeholder = `{${item.dVno}}`;
      const displayName = item.displayName ?? item.display ?? "";
      const entityId = item.entity ?? item.entityID ?? "";
      let replacement = "";

      if (item.type === "UserMention") {
        replacement = `@${displayName}`;
      } else if (item.type === "CompanyMention") {
        replacement = `@${displayName}`;
      } else if (item.type === "Hashtag") {
        replacement = `#${displayName}`;
      }

      result = result.replaceAll(placeholder, replacement);
    });

    return result;
  };

  useEffect(() => {
    if (articleDataInfo) {

      const rawHtml = articleDataInfo?.info?.postInfo?.postContent || "";
      const normalizedDynamicValues = normalizeDynamicValues(articleDataInfo?.info?.postInfo?.dynamicValues || []);
      const replacedForEditor = replaceDynamicValues(rawHtml, normalizedDynamicValues);
      setDescription(replacedForEditor);
      setPostInputValue(rawHtml)
      setPostDynamicValues(normalizedDynamicValues);
    }
  }, [articleDataInfo]);

  // useEffect(() => {
  //   if (showModal) {
  //     document.body.style.overflow = "hidden";
  //     document.documentElement.style.overflow = "hidden";
  //     document.body.classList.add("modal-open");
  //   } else {
  //     document.body.style.overflow = "unset";
  //     document.documentElement.style.overflow = "";
  //     document.body.classList.remove("modal-open");
  //   }
  // }, [showModal]);

  //Tags
  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get("/Posts/GetArticleTagsList");
        setTagOptions(response?.data?.responseData);
      } catch (error) {
        console.error("Failed to fetch tag options:", error);
      }
    };

    fetchTags();
  }, []);

  const handleTagChange = (values) => {
    setSelectedTags(values);
  };

  //Rich Text Editor
  const editorRef = useRef(null);

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link", "image"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
    clipboard: {
      matchVisual: true,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "script",
    "link",
    "image",
    "code-block",
    "color",
    "background",
    "align",
    "direction",
  ];

  //Add article
  const sessionId = localStorage.getItem("sessionId");

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [errorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [display, setDisplay] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [images, setImages] = useState([]);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const userUid = localStorage.getItem("userUid");
  const [description, setDescription] = useState("");

  const handleArticleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    if (source !== "user") {
      setDescription(content);
      return;
    }
    const caret = editor.getSelection()?.index || 0;

    setDescription(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(
      ({ type, displayName, display }) => {
        const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
        // const fullMention = `${prefix}${display||displayName}`;
        // return value.includes(fullMention);
        return value.includes(`${prefix}${displayName || display}`);

      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, displayName, display }) => {
      const prefix = type === "UserMention" || type === "CompanyMention" ? "@" : "#";
      const fullMention = `${prefix}${displayName || display}`;
      // const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      const regex = new RegExp(
        `${escapeRegex(fullMention)}(?=\\s|&nbsp;|<|$)`,
        "gi"
      );
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      setShowSuggestions(false);
    }
  };

  const insertMention = (suggestion, userUid, entityType) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" || entityType === "CompanyMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    // const updatedPostDynamicValues = [
    //   ...safePostDynamicValues,
    //   {
    //     type: mentionType,
    //     dVno,
    //     entity: mentionType === "UserMention" ? userUid : suggestion,
    //     display: displayName,
    //   },
    // ];
    let newDynamicValue = null;
    if (mentionType === "UserMention" || entityType === "CompanyMention") {
      newDynamicValue = {
        type: entityType || mentionType,
        dVno,
        entity: userUid, // userUid or companyUid
        display: displayName,
      };
    } else if (mentionType === "Hashtag") {
      newDynamicValue = {
        type: "Hashtag",
        dVno,
        entity: suggestion || displayName, // naya ya existing hashtag text
        display: displayName,
      };
    }
    const updatedPostDynamicValues = [...safePostDynamicValues, newDynamicValue]
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText("")
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.entityName : selectedItem?.hashTag,
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.userUid : null,
              selectedItem?.entityType,
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      } else if (e.key === " ") {
        // Space pressed while suggestions open:
        // - For hashtag: commit manual typed hashtag (SearchText) as mention
        // - For mention: just close suggestions
        if (mentionType === "Hashtag") {
          e.preventDefault();
          if (SearchText && SearchText.trim()) {
            insertMention(SearchText.trim(), null);
          }
        }
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    } else {
      if (e.key === " ") {
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    }
  };


  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemRefs.current = [];
    setSelectedIndex(0);
  }, [suggestions]);

  useEffect(() => {
    if (!showSuggestions) {
      setSelectedIndex(0);
    }
  }, [showSuggestions]);


  const [privacyType, setPrivacyType] = useState("Public");
  const Privacy = [
    { value: "Public", label: t("Newsfeed.Public"), icon: <PublicSharpIcon /> },
    { value: "Friends", label: t("Newsfeed.Friends"), icon: <GroupSharpIcon /> },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
    { value: "Custom", label: t("Newsfeed.Custom"), icon: <TuneSharpIcon /> },
  ];

  const normalizeDynamicValues = (dynamicValues = []) => {
    return (dynamicValues || []).map((dv, idx) => {
      if (!dv) return null;
      const {
        type,
        dVno,
        // possible incoming names:
        entity,
        entityID,
        entityId,
        userUid,
        displayName,
        display,
        entityName,
        hashTag,
      } = dv;

      // Determine the type first
      const resolvedType = type || (hashTag ? "Hashtag" : "UserMention");

      // Resolve the display name
      const resolvedDisplayName = displayName ?? display ?? entityName ?? hashTag ?? "";

      // Resolve the entity (ID for User/Company, Text/ID for Hashtag)
      let resolvedEntity = entity ?? entityID ?? entityId ?? userUid ?? hashTag ?? resolvedDisplayName;

      // 🚨 FIX: If it's a Hashtag, ensure the entity is the display name (text)
      // This forces the entity back to the human-readable text, overriding any server-side ID
      if (resolvedType === "Hashtag") {
        resolvedEntity = resolvedDisplayName;
      }

      return {
        type: resolvedType,
        dVno: dVno ?? idx + 1,
        entity: resolvedEntity,
        displayName: resolvedDisplayName,
      };

    }).filter(Boolean);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      setDisplay(true);
      const formData = new FormData();
      formData.append("ArticleID", articleId);
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("Title", title);
      formData.append("PostContent", postInputValue);
      // const normalizedDynamicValues = normalizeDynamicValues(postDynamicValues);
      formData.append("DynamicValues", JSON.stringify(postDynamicValues));
      // if (bannerImage instanceof File) {
      formData.append("BannerFile", bannerImage);
      // }
      formData.append("Tags", selectedTags);
      // formData.append("Tags", JSON.stringify(selectedTags));
      formData.append("langKey", language === "en" ? "" : language,);


      formData.append("PostId", postId);

      const res = await axios.post("/Posts/UpdateArticle", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const updatedContent = postInputValue || description;
      const updatedBannerUrl =
        bannerImage instanceof File ? imagePreview : null;

      const updatePostInfo = (postInfo = {}) => ({
        ...postInfo,
        title,
        description,
        postContent: updatedContent,
        dynamicValues: postDynamicValues,
        articleInfo: {
          ...postInfo.articleInfo,
          title,
          content: updatedContent,
          bannerUrl:
            updatedBannerUrl || postInfo.articleInfo?.bannerUrl,
        },
        mediaFilesList: updatedBannerUrl
          ? postInfo.mediaFilesList?.length
            ? postInfo.mediaFilesList.map((media, index) =>
                index === 0
                  ? { ...media, mediaName: updatedBannerUrl }
                  : media
              )
            : [{ mediaName: updatedBannerUrl }]
          : postInfo.mediaFilesList,
      });

      // ArticleDetail passes setArticle, while news-feed cards pass setPostList.
      // Guard both setters so each view updates immediately without throwing.
      if (typeof setArticle === "function") {
        setArticle((prev) =>
          prev
            ? {
                ...prev,
                articleTags_Name: selectedTags,
                info: {
                  ...prev.info,
                  postInfo: updatePostInfo(prev.info?.postInfo),
                },
              }
            : prev
        );
      }

      if (typeof setPostList === "function") {
        setPostList((prev = []) =>
          prev.map((post) =>
            post?.postInfo?.postId === postId
              ? {
                  ...post,
                  postInfo: updatePostInfo(post.postInfo),
                  articleTags_Name: selectedTags,
                }
              : post
          )
        );
      }

      const successMessage =
        res?.data?.message || "Article updated successfully";
      if (typeof onUpdateSuccess === "function") {
        onUpdateSuccess({
          postId,
          title,
          postContent: updatedContent,
          dynamicValues: postDynamicValues,
          articleTags_Name: selectedTags,
          bannerUrl: updatedBannerUrl,
        });
      }
      toast.success(successMessage);
      closeModal();

      setIsSubmitting(false);
    } catch (error) {
      console.error("Error updating article:", error);

      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(
          error.response?.data?.message || "Failed to update the article"
        );
        setShowErrorToast(true);
      }

      setIsSubmitting(false);
    }
  };


  //Image crop
  const CROP_RESOLUTIONS = [
    { id: "1920x1080", label: "1920 × 1080", width: 1920, height: 1080 },
    { id: "1280x720", label: "1280 × 720", width: 1280, height: 720 },
    { id: "800x450", label: "800 × 450", width: 800, height: 450 },
    { id: "original", label: "Original", width: null, height: null },
  ];

  const [bannerImage, setBannerImage] = useState(null);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [imagePreview, setImagePreview] = useState(null); // cropped preview after Apply
  const [originalBannerUrl, setOriginalBannerUrl] = useState(null); // original upload for re-crop
  const [cropper, setCropper] = useState(null);
  const [cropperKey, setCropperKey] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [showCropSettings, setShowCropSettings] = useState(false);
  const [cropMode, setCropMode] = useState("fixed"); // fixed | auto
  const [cropResolutionId, setCropResolutionId] = useState("1920x1080");

  useEffect(() => {
    if (!cropper) return;
    cropper.setAspectRatio(cropMode === "fixed" ? 16 / 9 : NaN);
  }, [cropMode, cropper]);

  const revokeIfBlobUrl = (url) => {
    if (url && typeof url === "string" && url.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {}
    }
  };

  // Re-open cropper with the original uploaded image
  const openBannerCropper = () => {
    if (!originalBannerUrl && !previewImageUrl && !(bannerImage instanceof Blob)) return;
    setCropper(null);
    setShowCropSettings(false);
    setCropperKey((key) => key + 1);
    setShowCropper(true);
  };

  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      setOriginalBannerUrl((prev) => {
        if (prev && prev !== imagePreview) revokeIfBlobUrl(prev);
        return imageUrl;
      });
      setImagePreview((prev) => {
        if (prev && prev !== imageUrl) revokeIfBlobUrl(prev);
        return imageUrl;
      });
      setBannerImage(file);
      setPreviewImageUrl(null);
      setCropper(null);
      setShowCropSettings(false);
      setCropperKey((key) => key + 1);
      setShowCropper(true);
    }
  };
  console.log("setImagePreview===>", imagePreview)
  // When crop is completed
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Apply crop and save image
  // const saveCroppedImage = async () => {
  //   try {
  //     const croppedImageUrl = await getCroppedImg(
  //       imagePreview,
  //       croppedAreaPixels,
  //       rotation
  //     );

  //     // Convert blob URL to File object
  //     const response = await fetch(croppedImageUrl);
  //     const blob = await response.blob();
  //     const file = new File([blob], "cropped-image.jpg", {
  //       type: "image/jpeg",
  //     });

  //     setBannerImage(file);
  //     setPreviewImageUrl(null); // Clear the old preview URL
  //     setShowCropper(false);
  //   } catch (e) {
  //     console.error("Error cropping image:", e);
  //   }
  // };
  // Apply crop and save image
const saveCroppedImage = async () => {
  try {
    if (!cropper) return;

    const selectedResolution =
      CROP_RESOLUTIONS.find((r) => r.id === cropResolutionId) ||
      CROP_RESOLUTIONS[0];

    let canvasOptions = {};
    if (selectedResolution.width && selectedResolution.height) {
      if (cropMode === "fixed") {
        canvasOptions = {
          width: selectedResolution.width,
          height: selectedResolution.height,
        };
      } else {
        const data = cropper.getData(true);
        const ratio = data.width / data.height || 16 / 9;
        canvasOptions = {
          width: selectedResolution.width,
          height: Math.round(selectedResolution.width / ratio),
        };
      }
    }

    const canvas = cropper.getCroppedCanvas(canvasOptions);
    if (!canvas) return;

    const blob = await new Promise((resolve) =>
      canvas.toBlob((b) => resolve(b), "image/jpeg", 0.92)
    );
    if (!blob) return;

    const file = new File([blob], "cropped-image.jpg", {
      type: "image/jpeg",
    });
    const croppedImageUrl = URL.createObjectURL(blob);

    setImagePreview((prev) => {
      if (prev && prev !== originalBannerUrl) revokeIfBlobUrl(prev);
      return croppedImageUrl;
    });
    setBannerImage(file);
    setPreviewImageUrl(null);
    setCropper(null);
    setShowCropper(false);
    setShowCropSettings(false);

  } catch (e) {
    console.error("Error cropping image:", e);
  }
};

  // Cancel cropping
  const cancelCropping = () => {
    setShowCropper(false);
    setImagePreview(null);
  };

  //   if (isLoading) {
  //     return (
  //       showModal && (
  //         <div
  //           className="modal fade show"
  //           tabIndex="-1"
  //           role="dialog"
  //           style={{ display: "block" }}
  //         >
  //           <div className="container articleContainer mt-4 mb-5 d-flex justify-content-center">
  //             <div className="col-12">
  //               <div className="bg-white pb-4">
  //                 <div className="row mb-md-4 mb-2 mt-md-4 mt-2">
  //                   <div className="modalBorder d-flex justify-content-between align-items-center p-2">
  //                     <h6>Loading article data...</h6>
  //                     <CloseSharpIcon className="pointer" onClick={closeModal} />
  //                   </div>
  //                 </div>
  //                 <div className="d-flex justify-content-center my-5">
  //                   <div className="spinner-border" role="status">
  //                     <span className="visually-hidden">Loading...</span>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )
  //     );
  //   }

  const handleArticleUpdateEscapeClose = useCallback(() => {
    if (showSuggestions) {
      setShowSuggestions(false);
      return;
    }
    closeModal();
  }, [showSuggestions, closeModal]);

  useEscapeKeyDown(showModal, handleArticleUpdateEscapeClose);

  return (
    <>
      {showModal && (
        <div
          className="modal fade show postAdd ArticleMainHuzScrollnone"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="container articleContainer modal-content">
            <div className="col-12">
              <form className="pb-4">
                <div className="row mb-md-4 mb-2  mt-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center">
                    <div className="AddedNewPostdiv">
                      <h6>{t("Newsfeed.Update Article")}</h6>

                      <SelectPrivacy
                        className="privacySelect"
                        classNamePrefix="privacySelect"
                        value={Privacy.find(
                          (option) => option.value === privacyType
                        ) || Privacy[0]}
                        onChange={(selectedOption) => {
                          setPrivacyType(selectedOption.value);
                        }}
                        options={Privacy}
                        placeholder={t("Newsfeed.Select Privacy")}
                        styles={privacySelectStyles}
                        isSearchable={false}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuShouldScrollIntoView={false}
                        formatOptionLabel={({ label, icon }) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {icon}
                            <span style={{ marginLeft: 8 }}>{label}</span>
                          </div>
                        )}
                      />
                    </div>
                    <CloseSharpIcon className="pointer" onClick={closeModal} />
                  </div>
                </div>

                <div className="row g-4">
                  <div className="col-12 mb-4">
                    <label className="form-label fw-medium">
                      {t("Newsfeed.Banner Image")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <div className="w-full max-w-4xl mx-auto">
                      {/* Article form fields would go here */}
                      <div className="mb-6">
                        {showCropper ? (
                          <div className="bg-white rounded shadow-sm p-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <h6 className="mb-0">{t("Newsfeed.Crop Your Image")}</h6>
                              <span
                                className="pointer"
                                style={{
                                  backgroundColor: "gainsboro",
                                  padding: "7px 10px 10px 10px",
                                  borderRadius: "50%",
                                }}
                                onClick={() => setShowCropSettings((prev) => !prev)}
                                title={t("Newsfeed.Crop Settings")}
                              >
                                <EditSharpIcon className="material-symbols-sharp" />
                              </span>
                            </div>

                            {showCropSettings && (
                              <div className="border rounded p-3 mb-3 bg-light">
                                <div className="mb-3">
                                  <label className="form-label small fw-medium mb-1">
                                    {t("Newsfeed.Crop Mode")}
                                  </label>
                                  <div className="d-flex gap-2">
                                    <button
                                      type="button"
                                      className={
                                        cropMode === "fixed"
                                          ? "mainBtn1"
                                          : "btn btn-sm btn-outline-secondary"
                                      }
                                      onClick={() => setCropMode("fixed")}
                                    >
                                      {t("Newsfeed.Fixed")}
                                    </button>
                                    <button
                                      type="button"
                                      className={
                                        cropMode === "auto"
                                          ? "mainBtn1"
                                          : "btn btn-sm btn-outline-secondary"
                                      }
                                      onClick={() => setCropMode("auto")}
                                    >
                                      {t("Newsfeed.Auto")}
                                    </button>
                                  </div>
                                </div>
                                <div>
                                  <label className="form-label small fw-medium mb-1">
                                    {t("Newsfeed.Resolution")}
                                  </label>
                                  <select
                                    className="form-select form-select-sm"
                                    value={cropResolutionId}
                                    onChange={(e) => setCropResolutionId(e.target.value)}
                                  >
                                    {CROP_RESOLUTIONS.map((res) => (
                                      <option key={res.id} value={res.id}>
                                        {res.id === "original"
                                          ? t("Newsfeed.Original")
                                          : res.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}

                            <div
                              style={{
                                position: "relative",
                                height: "240px",
                                background: "#f0f0f0",
                              }}
                              className="mb-3"
                            >
                              <Cropper
                                  key={cropperKey}
                                  src={originalBannerUrl || imagePreview || previewImageUrl}
                                  style={{ height: 240, width: "100%" }}
                                  aspectRatio={cropMode === "fixed" ? 16 / 9 : NaN}
                                  guides={true}
                                  viewMode={1}
                                  dragMode="move"
                                  cropBoxResizable={true}
                                  cropBoxMovable={true}
                                  background={false}
                                  responsive={true}
                                  autoCropArea={1}
                                  checkOrientation={false}
                                  onInitialized={(instance) => {
                                    setCropper(instance);
                                  }}
                                />
                            </div>

                            <div className="d-flex justify-content-end gap-2">
                              <button
                                type="button"
                                className="mainBtn"
                                onClick={saveCroppedImage}
                              >
                                {t("Newsfeed.Save")}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="card rounded-0">
                            <div className="card-body ArticleBannerHuzCard">
                              <div className="custom-file-upload text-center p-2">
                                {bannerImage || previewImageUrl ? (
                                  <div className="preview-container">
                                    <img
                                      src={
                                        bannerImage
                                          ? imagePreview || URL.createObjectURL(bannerImage)
                                          : previewImageUrl
                                      }
                                      alt="Preview"
                                      className="img-fluid mb-3"
                                      style={{ maxHeight: "300px" }}
                                    />
                                    <button
                                      type="button"
                                      className="border-0 position-absolute top-0 right-10 ArticleBannerHuzCardbtn"
                                      onClick={() => {
                                        setImagePreview((prev) => {
                                          if (prev && prev !== originalBannerUrl) {
                                            revokeIfBlobUrl(prev);
                                          }
                                          return null;
                                        });
                                        revokeIfBlobUrl(originalBannerUrl);
                                        setOriginalBannerUrl(null);
                                        setBannerImage(null);
                                        setPreviewImageUrl(null);
                                      }}
                                    >
                                      <CloseSharpIcon className="pointer-cursor" />
                                    </button>
                                    {(bannerImage || previewImageUrl) && (
                                      <div className="d-flex justify-content-center">
                                        <span
                                          className="pointer"
                                          style={{
                                            backgroundColor: "gainsboro",
                                            padding: "7px 10px 10px 10px",
                                            borderRadius: "50%",
                                          }}
                                          onClick={openBannerCropper}
                                        >
                                          <EditSharpIcon className="material-symbols-sharp" />
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <>
                                    <div className="upload-icon mb-3">
                                      <svg
                                        fill="currentColor"
                                        viewBox="0 0 36 36"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="36px"
                                        height="36px"
                                      >
                                        <title> {t("Newsfeed.image-line")}</title>
                                        <path d="M32,4H4A2,2,0,0,0,2,6V30a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V6A2,2,0,0,0,32,4ZM4,30V6H32V30Z" />
                                        <path d="M8.92,14a3,3,0,1,0-3-3A3,3,0,0,0,8.92,14Zm0-4.6A1.6,1.6,0,1,1,7.33,11,1.6,1.6,0,0,1,8.92,9.41Z" />
                                        <path d="M22.78,15.37l-5.4,5.4-4-4a1,1,0,0,0-1.41,0L5.92,22.9v2.83l6.79-6.79L16,22.18l-3.75,3.75H15l8.45-8.45L30,24V21.18l-5.81-5.81A1,1,0,0,0,22.78,15.37Z" />
                                      </svg>
                                    </div>
                                    <p className="mb-3">
                                     {t("Newsfeed.We recommend uploading or dragging in an image that is 1920x1080 pixels")}
                                    </p>

                                    <button
                                      className="mainBtn-upload"
                                      type="button"
                                      onClick={() =>
                                        document
                                          .getElementById("fileUpload")
                                          .click()
                                      }
                                    >
                                       {t("Newsfeed.Upload from file")}
                                    </button>
                                    <input
                                      id="fileUpload"
                                      type="file"
                                      className="d-none"
                                      accept="image/*"
                                      onChange={handleFileChange}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3 article-title-col">
                    <label className="form-label fw-medium"> {t("Newsfeed.Title")}<span className="text-danger ms-2">*</span></label>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        className="form-control HuzTitleInput"
                        placeholder= {t("Newsfeed.Enter article title")}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3 article-tags-col">
                    <label className="form-label fw-medium">{t("Newsfeed.Tags")}<span className="text-danger ms-2">*</span></label>
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder= {t("Newsfeed.Enter Tags")}
                      onChange={handleTagChange}
                      value={selectedTags}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      dropdownStyle={{
                        zIndex: 9999,
                        position: "fixed",
                      }}
                    >
                      {tagOptions.map((tag) => (
                        <Select.Option key={tag?.atmid} value={tag?.tagName}>
                          {/* {tag?.tagName} */}
                            {tag?.tagName.replace(/[\[\]"\\]/g, "").trim()}   
                        </Select.Option>
                      ))}
                    </Select>
                  </div>

                  <div className="col-12 mb-4">
                    <label className="form-label fw-medium">{t("Newsfeed.Content")}<span className="text-danger ms-2">*</span></label>
                    <ReactQuill
                      ref={editorRef}
                      value={description}
                      onChange={(content, delta, source, editor) => {
                        handleArticleChange(content, delta, source, editor);
                      }}
                      modules={modules}
                      formats={formats}
                      onKeyDown={handleKeyDown1}
                      theme="snow"
                      className="form-quill"
                      placeholder= {t("Newsfeed.Write or paste your article content here...")}
                    />
                    {showSuggestions && (
                      <ul className="suggestion-box">
                        {mentionType === "Hashtag" ? <li
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevent editor blur
                            insertMention(
                              SearchText,
                              null
                            );
                          }}
                          className="suggestion-item"
                        >
                          <span>{SearchText ? `#${SearchText}` : ''}</span>
                        </li> : null}
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault(); // Prevent editor blur
                              e.stopPropagation();
                              insertMention(
                                mentionType === "UserMention"
                                  ? item?.entityName
                                  : item?.hashTag,
                                mentionType === "UserMention"
                                  ? item?.userUid
                                  : null,
                                item.entityType
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img
                                  src={item?.avatar}
                                  alt={item?.entityName}
                                  className="avatar"
                                />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* {showSuggestions && (
                      <ul className="suggestion-box">
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(
                                mentionType === "UserMention"
                                  ? item?.entityName
                                  : item?.hashTag,
                                mentionType === "UserMention"
                                  ? item?.userUid
                                  : null
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img
                                  src={item?.avatar}
                                  alt={item?.entityName}
                                  className="avatar"
                                />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )} */}
                  </div>

                  <div className="col-12 article-modal-footer d-flex justify-content-end">
                    {/* <div className="text-center mt-2"> */}
                    <button
                      color=""
                      className="closebtn me-2"
                      onClick={closeModal}
                    >
                      {t("Connections.Cancel")} 
                    </button>
                    {/* </div> */}
                    <button
                      type="button"
                      className="mainBtn"
                      disabled={isSubmitting}
                      onClick={handleSubmit}
                    >
                       {t("Newsfeed.Update")} 
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ArticleUpdate;
